<template>
  <div id="app-login">
    <form class="form-signin" @submit.prevent="checkEmail()">
      <h1 class="h3 mb-3 font-weight-normal">Wachtwoord vergeten</h1>
      <label for="inputEmail" class="sr-only">E-mailadres</label>
      <input
        v-model="user.email"
        type="email"
        id="inputEmail"
        class="form-control"
        placeholder="E-mailadres"
        required
        autofocus
      />

      <p v-html="wachtwoordFeedback">{{ wachtwoordFeedback }}</p>

      <button class="btn btn-lg btn-primary btn-block" type="submit">
        Nieuw wachtwoord aanvragen
      </button>
    </form>
  </div>
</template>

<script>
//import $ from "jquery";
import "bootstrap";
import axios from "axios";

export default {
  name: "app",
  components: {},
  data() {
    return {
      user: {
        email: "",
      },
      wachtwoordFeedback: "",
    };
  },
  created() {},
  mounted() {},
  methods: {
    checkEmail() {
      axios
        .post("https://hofman.weblion.be/api/gebruikers/reset_email.php", {
          email: this.user.email,
        })
        .then((res) => {
          if (res.data) {
            this.wachtwoordFeedback =
              "Er is een e-mail verstuurd naar je e-mailadres. <br> Volg de instructies in de e-mail om je wachtwoord opnieuw in te stellen.";
          } else {
            this.wachtwoordFeedback =
              "Er ging iets fout. Probeer later nog eens om je wachtwoord opnieuw in te stellen.";
          }
        })
        .then(function () {});
    },
  },
};
</script>

<style>
#app-login {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.form-signin {
  width: 100%;
}

.form-signin input {
  margin-bottom: 5px;
}
</style>
